import React from 'react';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { isFilteringByStatusDateRange, selectParsedStatusTrace } from 'store/Manage/selectors';
import Skeleton from 'Common/Components/Skeleton';
import { Wrapper, Item } from './styled';
import { selectFilterHistory } from 'store/Filters/selectors';

const StatusTraceCell = ({ vuln, showSkeleton, entity }) => {
  const intl = useIntl();
  const statusTrace = get(vuln, 'status_history', []);
  const createDate = get(vuln, 'metadata.create_time', '');
  const owner = get(vuln, 'metadata.owner', '');
  const tool = get(vuln, 'tool', '');
  const creator = tool === 'Web UI' ? owner : 'System';
  const parsedStatusTrace = useSelector(() => selectParsedStatusTrace(statusTrace, createDate, creator));
  const parsedStatus = (status) => intl.formatMessage({ id: `manage.cm.status.${status}` });
  const formatDate = (d) => moment(d).format('D/M/YYYY HH:mm');
  const filters = useSelector((state) => selectFilterHistory(entity, state));
  const filtersStatusTraceDate = filters?.filter((f) => f.name === 'status_history__change_date' && f.op === 'range');
  const values = filtersStatusTraceDate?.map((el) => el.val);
  const dates = values?.map((el) => el.split(','));
  const greaterThan = dates?.map((el) => el[0]);
  const lessThan = dates?.map((el) => el[1]);
  const isFilteringByStatusDate = useSelector((state) => isFilteringByStatusDateRange(state, entity));
  const filteredTrace = isFilteringByStatusDate
    ? parsedStatusTrace.filter((item) => {
      return greaterThan.some((gt) => item.change_date >= gt) && lessThan.some((lt) => item.change_date <= lt);
    })
    : parsedStatusTrace;

  if (showSkeleton) return <Skeleton />;
  if (!filteredTrace) return null;
  return (
    <Wrapper>
      { filteredTrace?.length > 0 && filteredTrace.map((item, i) =>
        <Item
          key={ `${item.status}-${i}` }
          status={ item.status }
          title={ `${parsedStatus(item.status)}\n\nby: ${item.user || 'System'}\n\ndate: ${formatDate(item.change_date)}` }
          singleItem={ filteredTrace.length === 1 }
        />)
      }
    </Wrapper>
  );
};

export default StatusTraceCell;
